import React, {useState, useContext }from "react";
import {Button, Modal, ModalHeader} from "reactstrap";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import ThemeRoutes from "../routes/router";
import { useSelector } from 'react-redux';

import {StateContext} from "../utils/context";

import { useTranslation } from "react-i18next";

const ContainerTab = ({ name, buttonArr }) => {
  const {currentUser} = useContext(StateContext);
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const landings = useSelector((state) => state.landings)
  const musicLinksUrlParts = useSelector((state) => state.musicLinks)
  const [modalErrorOpen, setModalErrorOpen] = useState(false);
  const MAX_URL_PARTS = 10;
  const ALLOWED_PAYMENT_METHODS = 3;
  const ALLOWED_LABELS_DEMO_USER = 3;
  const ALLOWED_ARTISTS_DEMO_USER = 3;

  buttonArr = [];
  let routeList = ThemeRoutes;

  ThemeRoutes.forEach(function(item, index) {
    item.hasOwnProperty("addButton") && buttonArr.push(item);
  });

  const currentLocation = location.pathname;

  const newName = routeList.filter(i => {
    if ( !(i.path.includes(':id')) && i.path === currentLocation) {
      return i;
    } else if (i.path.includes(':id')){
      let newPathName = currentLocation.split('/');
      newPathName[2] = ':id';
      const joinded = newPathName.join('/');
      if (joinded === i.path) {
        return i
      }
    }
  });


  const handleClickLink = (path) => {

    if(location.pathname.split('/')[1] === 'landing' && landings.length >= 5){
      setModalErrorOpen(true)
      return
    }
    history.push({pathname: `${path}/add`})
  }

  const fnToggle = () => {
    setModalErrorOpen(!modalErrorOpen)
  }

  return (
    <div className="page-breadcrumb bg-white">
      <div className="containerTab">
        <div>
          <h5 className="font-bold text-uppercase mb-0">{newName.length > 0 ? t(`${newName[0].headerText}`) : ''}</h5>
        </div>

        <div className="flexBetween">
          {buttonArr.map(item => {
                if ((!currentUser.distribution ) && (item.path === currentLocation) && (item.buttonText === "router.releases.view.buttonText")) {
                  return (
                    <>
                      <Button key={item.buttonText} className="btn btn-outline-primary" style={{marginRight: '10px'}} disabled>
                        {t(`${item.buttonText}`)}
                      </Button>
                      <Button key={item.secondaryButtonText} className="btn btn-outline-primary" disabled>
                        {t(`${item.secondaryButtonText}`)}
                      </Button>
                    </>
                  )
                }
                else if ((!currentUser.unlimited_track_amount && (currentUser.total_allowed_track_amount <= 0)) &&  (item.path === currentLocation) && (item.buttonText === "router.releases.view.buttonText")) {
                  return (
                    <>
                      <Button key={item.buttonText} className="btn btn-outline-primary" style={{marginRight: '10px'}} disabled>
                        {t(`${item.buttonText}`)}
                      </Button>
                      <Button key={item.secondaryButtonText} className="btn btn-outline-primary" disabled>
                        {t(`${item.secondaryButtonText}`)}
                      </Button>
                    </>
                  )
                }
                else if ((currentUser.distribution) && ((currentUser.unlimited_track_amount) || (currentUser.total_allowed_track_amount > 0)) && (item.path === currentLocation) && (item.path === "/releases")) {
                  return (
                    <>
                      <Button
                        key={item.buttonText}
                        className="btn btn-outline-primary"
                        onClick={() => history.push({pathname: `/releases/add`})}
                        style={{marginRight: '10px'}}
                        >
                        {t(`${item.buttonText}`)}
                      </Button>
                      <Button
                        key={item.secondaryButtonText}
                        className="btn btn-outline-primary"
                        onClick={() => history.push({pathname: `/releases/transfer`})}
                        disabled={!currentUser.release_transfer}
                        style={{marginRight: '10px'}}
                        >
                        {t(`${item.secondaryButtonText}`)}
                      </Button>
                    </>
                  )
                }
                else if ((!currentUser.promotions) && (item.path === currentLocation) &&  (item.buttonText === "Add New Promotion" || item.buttonText === "Add New List" || item.buttonText === "Add New Recipient" || item.buttonText === "router.featureRequest.view.buttonText")) {
                  return (
                    <Button key={item.buttonText} className="btn btn-outline-primary" disabled>
                      {t(`${item.buttonText}`)}
                    </Button>
                  )
                }
                else if ((currentUser.promotion_amount_left <= 0) && (item.path === currentLocation) &&  (item.buttonText === "Add New Promotion")) {
                  return (
                    <Button key={item.buttonText} className="btn btn-outline-primary" disabled>
                      {t(`${item.buttonText}`)}
                    </Button>
                  )
                }
                else if ((!currentUser.artists) && (item.path === currentLocation) &&  (item.buttonText === "router.artists.view.buttonText")) {
                  return (
                    <Button key={item.buttonText} className="btn btn-outline-primary" disabled>
                      {t(`${item.buttonText}`)}
                    </Button>
                  )
                }
                else if ((currentUser.artists) && (item.path === currentLocation) && (!currentUser.is_paid_subscription) && (currentUser.total_artists >= ALLOWED_ARTISTS_DEMO_USER) &&  (item.buttonText === "router.artists.view.buttonText")) {
                  return (
                    <Button key={item.buttonText} className="btn btn-outline-primary" disabled>
                      {t(`${item.buttonText}`)}
                    </Button>
                  )
                }
                else if ((!currentUser.labels_enabled) && (item.path === currentLocation) &&  (item.buttonText === "router.labels.view.buttonText")) {
                  return (
                    <Button key={item.buttonText} className="btn btn-outline-primary" disabled>
                      {t(`${item.buttonText}`)}
                    </Button>
                  )
                }
                else if ((currentUser.labels_enabled) && (item.path === currentLocation) && (!currentUser.is_paid_subscription) && (currentUser.total_labels >= ALLOWED_LABELS_DEMO_USER) &&  (item.buttonText === "router.labels.view.buttonText")) {
                  return (
                    <Button key={item.buttonText} className="btn btn-outline-primary" disabled>
                      {t(`${item.buttonText}`)}
                    </Button>
                  )
                }
                else if ((!currentUser.mastering) && (item.path === currentLocation) &&  (item.buttonText === "router.mastering.view.buttonText")) {
                  return (
                    <Button key={item.buttonText} className="btn btn-outline-primary" disabled>
                      {t(`${item.buttonText}`)}
                    </Button>
                  )
                }
                else if ((currentUser.total_payment_methods >= ALLOWED_PAYMENT_METHODS) && (item.path === currentLocation) &&  (item.buttonText === "router.paymentMethods.view.buttonText")) {
                  return (
                    <Button key={item.buttonText} className="btn btn-outline-primary" disabled>
                      {t(`${item.buttonText}`)}
                    </Button>
                  )
                }
                else if ((!currentUser.can_add_invoices || !currentUser.invoicing_available || currentUser.invoices_generating>0 ) && (item.path === currentLocation) &&  (item.buttonText === "router.invoices.view.buttonText")) {
                  if(!currentUser.is_sub_user) {
                    return (
                      <Button key={item.buttonText} className="btn btn-outline-primary" disabled>
                        {t(`${item.buttonText}`)}
                      </Button>
                    )
                  }
                }
                else if ((!currentUser.artists_accounting) && (item.path === currentLocation) &&  (item.buttonText === "router.accounting.view.buttonText")) {
                  return (
                    <Button key={item.buttonText} className="btn btn-outline-primary" disabled>
                      {t(`${item.buttonText}`)}
                    </Button>
                  )
                }
                else if ((!currentUser.link_in_bio || currentUser.link_landing_page_allowance <= 0) && (item.path === currentLocation) &&  (item.buttonText === "outer.linkLandingPage.view.buttonText")) {
                  return (
                    <Button key={item.buttonText} className="btn btn-outline-primary" disabled>
                      {t(`${item.buttonText}`)}
                    </Button>
                  )
                }
                else if ((!currentUser.music_link || currentUser.music_link_allowance <= 0) && (item.path === currentLocation) &&  (item.buttonText === "router.musicLink.view.buttonText")) {
                  return (
                    <Button key={item.buttonText} className="btn btn-outline-primary" disabled>
                      {t(`${item.buttonText}`)}
                    </Button>
                  )
                }
                else if ((!currentUser.music_link || currentUser.music_link_allowance <= 0) && (item.path === currentLocation) &&  (item.buttonText === "router.musicLinkUrlpart.view.buttonText")) {
                  return (
                    <Button key={item.buttonText} className="btn btn-outline-primary" disabled>
                      {t(`${item.buttonText}`)}
                    </Button>
                  )
                }
                else if ((item.path === currentLocation) &&  (item.buttonText === "router.subUsers.view.buttonText")) {
                    if(currentUser.is_premium_user && !currentUser.is_sub_user)
                    {
                      return (
                        <Button 
                          key={item.buttonText}                          
                          onClick={() => history.push({pathname: `/sub-users/add`})}
                          className="btn btn-outline-primary"
                        >
                          {t(`${item.buttonText}`)}
                        </Button>
                      )
                    }
                    else
                    {
                      return (
                        <Button key={item.buttonText} className="btn btn-outline-primary" disabled>
                          {t(`${item.buttonText}`)}
                        </Button>
                      )
                    }
                }
                else if ((currentUser.credits<=0 ) &&  (item.path === currentLocation) && (item.buttonText === "router.mastering.view.buttonText")) {
                  return (
                    <Button key={item.buttonText} className="btn btn-outline-primary" disabled>
                      {t(`${item.buttonText}`)}
                    </Button>
                  )
                }
                else {
                  return item.path === currentLocation && (
                    <>
                      {item.path === '/music-link' && <Button
                        key={`${item.name}_1`}
                        className="btn btn-outline-primary"
                        onClick={() => history.push({pathname: `/music-link-urlpart`})}
                        style={{marginRight: '10px'}}
                      >
                        {t(`${item.secondaryButtonText}`)}
                      </Button>}
                      <Button
                        key={item.name}
                        className="btn btn-outline-primary"
                        onClick={() => handleClickLink(item.path)}
                        disabled={['/music-link-urlpart'].includes(item.path) && (!currentUser.is_premium_user && musicLinksUrlParts?.length > (MAX_URL_PARTS - 1))}
                      >
                        {t(`${item.buttonText}`)}
                      </Button>
                    </>
                  )
                }
            }


          )}
          {/* <!--a
            className="btn btn-danger text-white float-right ml-3 d-md-block"
            href="https://platform.music-link.io/help"
            rel="noopener noreferrer"
          >
            Help Center
          </a--> */}

          <Modal isOpen={modalErrorOpen} toggle={fnToggle} centered={true}>
            <ModalHeader>
              Sorry, but you can create only 5 landings
            </ModalHeader>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default ContainerTab;
